import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { AmazonMWSLinkedService } from 'app/model/linkedservice/amazon-mws.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonMWSLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                marketplaceID: '*',
                sellerID: '*',
                mwsAuthToken: 'secret',
                accessKeyId: '*',
                secretKey: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class AmazonMWSLinkedServiceAdapter extends LinkedServiceAdapter<AmazonMWSLinkedService> {
    protected modelConstructor(): new () => AmazonMWSLinkedService {
        return AmazonMWSLinkedService;
    }

    protected model(): IModel {
        return AmazonMWSLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AmazonMWSLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AmazonMWSLinkedService;
        properties.type = Metamodel.modelFor(AmazonMWSLinkedService).name;
        const mwsAuthToken = passwordOrAKVtoSecretBase(linkedService.mwsAuthToken, this.context);
        const secretKey = passwordOrAKVtoSecretBase(linkedService.secretKey, this.context);
        properties.typeProperties = {
            endpoint: linkedService.endpoint,
            marketplaceID: linkedService.marketplaceID,
            sellerID: linkedService.sellerID,
            mwsAuthToken,
            accessKeyId: linkedService.accessKeyId,
            secretKey,
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AmazonMWSLinkedService): Promise<AmazonMWSLinkedService> {
        const properties = linkedServiceResource.properties as Model.AmazonMWSLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.AmazonMWSLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.endpoint = typeProperties.endpoint;
        linkedService.marketplaceID = typeProperties.marketplaceID;
        linkedService.sellerID = typeProperties.sellerID;
        linkedService.mwsAuthToken = secretBaseToPasswordOrAKV(properties.typeProperties.mwsAuthToken, !!typeProperties.sellerID, this.context);
        linkedService.accessKeyId = typeProperties.accessKeyId;
        linkedService.secretKey = secretBaseToPasswordOrAKV(typeProperties.secretKey, !!typeProperties.accessKeyId, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
